import { useEffect } from 'react';
import { shell } from '@frontend/shell-utils';

type UseLegacyOnboardingCompactModeParams = {
  appState: string;
  showOnboardingFlow?: boolean;
  existingUser?: boolean;
  isLegacyUser?: boolean;
  setExistingUser: (value: boolean) => void;
  setShowExpandModeNudge: (value: boolean) => void;
};

export const useLegacyOnboardingCompactMode = ({
  appState,
  showOnboardingFlow,
  existingUser,
  isLegacyUser,
  setExistingUser,
  setShowExpandModeNudge,
}: UseLegacyOnboardingCompactModeParams) => {
  useEffect(() => {
    if (!showOnboardingFlow || existingUser || !isLegacyUser || appState !== 'LOCATION_SELECTION') {
      return;
    }

    shell?.invoke?.('main:update-options', { width: 400 });

    setExistingUser(true);
    setShowExpandModeNudge(true);
  }, [appState, showOnboardingFlow, existingUser, isLegacyUser, setExistingUser, setShowExpandModeNudge]);
};
